import { createContext } from 'react';
var RowContext = createContext({
  gutter: 0,
  breakpoint: 'xxs'
});
export default RowContext;